import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Motion";

const REQUIREMENTS = [
  { k: "Board", v: "Female models" },
  { k: "Minimum height", v: "173 cm" },
];

export const ScoutingCTA = () => (
  <section data-testid="scouting-section" className="relative overflow-hidden bg-white border-t border-[#1c1418]/15 px-5 py-24 text-[#1c1418] md:px-10 md:py-36">
    <div className="mx-auto grid max-w-[1400px] gap-16 lg:grid-cols-12">
      <Reveal className="lg:col-span-7">
        <p className="w-fit border border-[#1c1418] px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]">Open call · Scouting</p>
        <h2 className="mt-8 font-display text-6xl uppercase leading-[0.88] md:text-8xl lg:text-[8rem]">Your face<br />could be<br />next<span className="text-[#1c1418]">.</span></h2>
        <div className="mt-6 w-fit -rotate-2 bg-[#1c1418] px-4 py-1.5 font-display text-2xl uppercase text-white md:text-3xl">No experience needed</div>
        <p className="mt-10 max-w-lg font-serif text-xl italic text-[#1c1418]/80">Send a few natural photos, your height and your details. Our scouts review every application.</p>
        <Link to="/apply" data-testid="scouting-apply-button" className="mt-10 inline-flex items-center gap-3 bg-[#1c1418] px-8 py-4 font-mono text-xs uppercase tracking-[0.25em] text-white transition-transform hover:-translate-y-1">
          Start your application <ArrowUpRight className="h-4 w-4 text-[#e9458f]" />
        </Link>
      </Reveal>
      <Reveal delay={0.15} className="self-end lg:col-span-5">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/70">What we look for</p>
        <ul className="mt-4 border-t border-[#1c1418]/20" data-testid="scouting-requirements">
          {REQUIREMENTS.map((r) => (
            <li key={r.k} className="group flex items-baseline justify-between gap-4 border-b border-[#1c1418]/20 py-5">
              <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#1c1418]">{r.k}</span>
              <span className="font-display text-4xl uppercase transition-transform group-hover:-translate-x-2 md:text-5xl">{r.v}</span>
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
